<template>
  <div class="demo">
    <div class="content">
      <ul v-if="range">
        <li class="block blue" v-for="index in range" :data-index="index" :key="index" v-intersection="yourFn">
          {{ index }}
        </li>
      </ul>
      <transition-group v-if="navlist" name="in-view" class="Pagination" tag="ul">
        <li v-for="item in navlist" :key="item" class="in-view-item">
          {{ item }}
        </li>
      </transition-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      range: Array.from({ length: 10 }, (_, i) => i + 1),
      ishowList: {},
    };
  },
  computed: {
    navlist() {
      return Object.entries(this.ishowList)
        .sort((a, b) => Number(a) - Number(b))
        .filter(([, e]) => e)
        .map(([id]) => id);
    },
  },

  methods: {
    yourFn(entries, observer, isIntersecting) {
      let id = entries[0].target.dataset.index;

      this.$set(this.ishowList, id, isIntersecting);
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  margin: 1vh;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffebd1;
  font-weight: 600;
}
.demo {
  position: relative;
}
.Pagination {
  position: absolute;
  right: 30px;
  top: 50%;

  transform: translateY(-50%);

  li {
    width: 20px;
    height: 20px;
    border-color: rgba(170, 106, 175, 0.8);
    background-color: rgba(133, 155, 179, 1);
    color: #ffebd1;
    font-weight: 600;
    border-radius: 4px;
    margin: 5px 0;
  }
}

.in-view-item {
  transition: all 0.75s;
  display: block;
}
.in-view-enter {
  opacity: 0;
  transform: translateX(30px);
}
.in-view-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.in-view-leave-active {
  position: absolute;
}
</style>
